class ClassBrokerContact {

    constructor() {
        this.getObjects = this.getObjects();
    }

    getObjects = () => {
        return {
            name: '',
            email: '',
            phone: '',
            acceptPolicy: false,
        }
    }
}

export default ClassBrokerContact;